import { h, Component } from 'preact'
import ReferencesAPI from '../api/ReferencesAPI'
import References from '../components/References'
import LoadMoreReferences from '../components/LoadMoreReferences'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      references: [],
      count: 3,
      offset: 0,
      totalAmountReferences: null,
      loadedAllReferences: false,
      isLoading: true,
      error: false,
    }

    this.handleLoadMore = this.handleLoadMore.bind(this)
  }

  componentDidMount() {
    this.setCount()
    this.fetchReferences()
  }

  setCount() {

    if ( window.innerWidth < 1000 ) {
      this.setState({
        count: 2
      })
    }
  }

  fetchReferences() {
    this.setState({ isLoading: true })

    ReferencesAPI.all(this.state)
    .then(response => {
      this.setState({
        totalAmountReferences: response.headers.get('x-wp-total')
      })
      return response.json()
    })
    .then(data => {
      window.setTimeout(() => {
        this.setState({
          references: [...this.state.references, ...data],
          loadedAllReferences: false,
          isLoading: false
        })
        this.verifyLoadedAllReferences()
      }, 500)
    }).catch(error => {
      this.setState({
        error: true,
        isLoading: false
      })
    })
  }

  verifyLoadedAllReferences() {
    if ( this.state.totalAmountReferences == this.state.references.length ) {
      return this.setState({
        loadedAllReferences: true
      })
    }

    return false
  }

  handleLoadMore() {
    this.setState( (prevState) => {
      return {
        offset: prevState.offset + this.state.count
      }
    }, this.fetchReferences )
  }

  render() {
    return (
        <div className="c-references-app">

        <References
    references={this.state.references}
    loading={this.state.isLoading}
    error={this.state.error}
    language={this.props.language}
    />

    <LoadMoreReferences
    onLoadMore={this.handleLoadMore}
    nrShowing={this.state.references.length}
    nrAll={this.state.totalAmountReferences}
    loading={this.state.isLoading}
    language={this.props.language}
    />

    </div>
  )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/js/references/containers/App.js